import React, { useRef } from 'react';
// eslint-disable-next-line no-restricted-imports
import { useWatch } from 'react-hook-form-v7';
import CollapsibleFilterWrapper from '../CollapsibleFilterWrapper';
import ConnectedDatePicker from './ConnectedDatePicker';

const CollapsibleDatePicker = ({ control, name, label, tooltip, disabled = false }) => {
    const datePickerRef = useRef(null);
    const dateValue = useWatch({ control, name });

    const handleReset = () => datePickerRef.current.clear();

    return (
        <CollapsibleFilterWrapper
            label={`${label} (${dateValue ? 1 : 0})`}
            onReset={handleReset}
            tooltip={tooltip}
            disabled={disabled}
        >
            <ConnectedDatePicker
                ref={datePickerRef}
                control={control}
                name={name}
                disabled={disabled}
            />
        </CollapsibleFilterWrapper>
    );
};

export default CollapsibleDatePicker;
